import { Flex, Icon, Text, FlexProps } from 'pounceV2';
import React from 'react';
import { useTheme } from '@mui/material';
import { getFlowChartColors } from '../../constantsV3';

const RuleErrorTagV3: React.FC<React.PropsWithChildren<FlexProps>> = ({ children, ...rest }) => {
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  return (
    <Flex direction="row" align="center" gap={1} {...rest}>
      <Icon
        color={FLOW_CHART_COLORS.ERROR.BORDER}
        size="x-small"
        type="warning"
        p={0}
        marginBottom="-1px"
      />
      <Text variant="body/sm" color={FLOW_CHART_COLORS.ERROR.BORDER}>
        {children}
      </Text>
    </Flex>
  );
};

export default RuleErrorTagV3;
